<template>
  <v-menu open-on-hover offset-y v-bind="menu">
    <template v-slot:activator="{ on, attrs }">
      <v-icon size="22" v-bind="attrs" v-on="on" :color="iconColor">
        mdi-help-circle-outline
      </v-icon>
    </template>
    <v-card :height="height" :width="width">
      <v-toolbar height="25" flat color="primary">
        <v-icon class="abs-left" size="15" color="white"
          >mdi-help-circle-outline</v-icon
        >
        <v-toolbar-title class="white--text flex text-center titulo-ayuda">
          Ayuda
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="text-justify">
        <div v-html="texto"></div>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: {
    texto: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: "300px",
    },
    height: {
      type: String,
      default: "150px",
    },
    menu: {
      type: Object,
      default: () => {
        return { bottom: true };
      },
    },
    iconColor: {
      type: String,
      default: "default",
    },
  },
};
</script>
